import { gql } from '@apollo/client';

export const GENERATE_AUDIT_REPORT = gql`
  mutation GenerateAuditReport($sessionId: ID!) {
    generateAuditReport(sessionId: $sessionId) {
      id
      createdAt
      createdBy
      metrics {
        overall {
          precision
          recall
          f1Score
          accuracy
        }
        labelComparison {
          exactMatchCount
          exactMatchPercentage
          additionalLabelsCount
          additionalLabelsPercentage
          labelsMissingCount
          labelsMissingPercentage
          bothMissingAndAdditionalCount
          bothMissingAndAdditionalPercentage
        }
        byLabel {
          label
          metrics {
            precision
            recall
            f1Score
            accuracy
          }
        }
      }
    }
  }
`;
